interface SvgAttrs {
  viewBox: string
  stroke: string
  strokeWidth?: number
}

const svgIcon = ({ viewBox, stroke, strokeWidth = 1 }: SvgAttrs, content: string): string =>
  `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="${viewBox}" fill="none" stroke="${stroke}" stroke-linecap="round" stroke-linejoin="round" stroke-width="${strokeWidth}">${content}</svg>')`

export const iconClose = (stroke: string) =>
  svgIcon(
    {
      viewBox: '0 0 24 24',
      strokeWidth: 2,
      stroke,
    },
    '<path d="M1.458 1.458l21.084 21.084m0-21.084L1.458 22.542" />',
  )

export const iconBack = (stroke: string) =>
  svgIcon(
    {
      viewBox: '0 0 16 11',
      stroke,
    },
    '<path d="M1 5.5h15M5.5.55L.55 5.5l4.95 4.95" />',
  )

export const iconArrow = (stroke: string) =>
  svgIcon(
    {
      viewBox: '0 0 12 12',
      stroke,
    },
    '<path fill="none" d="M1 3.95L5.95 8.9l4.95-4.95" />',
  )

export const iconCheckmark = (stroke: string) =>
  svgIcon(
    {
      viewBox: '0 0 12 12',
      strokeWidth: 2,
      stroke,
    },
    '<path fill="none" d="M2.11 5.56l2.83 2.83 4.95-4.95" />',
  )

export const iconCircle = (fill: string) =>
  `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 8 8"><circle r="3" fill="${fill}" /></svg>')`
